import moment from "moment-business-days";
import constants from "./constants";

export default {
  toMoment(value) {
    if (!value) return null;
    return moment(value);
  },

  getDatesByQuickFilter(code) {
    switch (code) {
      case constants.DATE_QUICK_FILTER.CODE.HOM_NAY:
        let from = new moment().startOf("day").toDate();
        let to = new moment().startOf("day").toDate();
        return [from, to];

      case constants.DATE_QUICK_FILTER.CODE.TUAN_NAY:
        from = new moment().startOf("week").toDate();
        to = new moment()
          .endOf("week")
          .startOf("day")
          .toDate();
        return [from, to];

      case constants.DATE_QUICK_FILTER.CODE.NAM_NAY:
        from = new moment().startOf("year").toDate();
        to = new moment()
          .endOf("year")
          .startOf("day")
          .toDate();
        return [from, to];

      case constants.DATE_QUICK_FILTER.CODE.LAST_WEEK:
        to = new moment().startOf("day");
        from = new moment().startOf("day").add(-7, "days");
        return [from.toDate(), to.toDate()];

      case constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS:
        to = new moment().startOf("day");
        from = new moment().startOf("day").add(-30, "days");
        return [from.toDate(), to.toDate()];

      case constants.DATE_QUICK_FILTER.CODE.LAST_YEAR:
        to = new moment().startOf("day");
        from = new moment().startOf("day").add(-365, "days");
        return [from.toDate(), to.toDate()];

      case constants.DATE_QUICK_FILTER.CODE.THIS_MONTH:
        to = new moment().startOf("day");
        from = new moment().startOf("month");
        return [from.toDate(), to.toDate()];

      case constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2:
        to = new moment().endOf("month").startOf("day");
        from = new moment().startOf("month");
        return [from.toDate(), to.toDate()];

      case constants.DATE_QUICK_FILTER.CODE.LAST_MONTH:
        to = new moment()
          .subtract(1, "months")
          .endOf("month")
          .startOf("day");
        from = new moment().subtract(1, "months").startOf("month");
        return [from.toDate(), to.toDate()];

      case constants.DATE_QUICK_FILTER.CODE.LAST_YEAR_2:
        to = new moment()
          .subtract(1, "years")
          .endOf("year")
          .startOf("day");
        from = new moment().subtract(1, "years").startOf("year");
        return [from.toDate(), to.toDate()];

      case constants.DATE_QUICK_FILTER.CODE.TO_TRINH_QUA_HAN_DEFAULT_RANGE:
        to = new moment().startOf("day").subtract(5, "day");
        from = new moment(to).subtract(3, "month");
        return [from.toDate(), to.toDate()];

      default:
        return [null, null];
    }
  },

  getTimesByQuickFilter(code) {
    let dateRange = this.getDatesByQuickFilter(code);
    let from = dateRange[0];
    let to = dateRange[1];
    return [from ? from.getTime() : null, to ? to.getTime() : null];
  },

  getDiffBaseWorkingDay(date1, date2) {
    let date1_ = this.toMoment(date1);
    let date2_ = this.toMoment(date2);
    let diff = date1_.businessDiff(date2_);
    return diff;
  },

  isDiff(date1, date2) {
    return (
      (date1 && !date2) ||
      (!date1 && date2) ||
      (date1 && date2 && date1.getTime() !== date2.getTime())
    );
  },

  isSameDate(time1, time2) {
    let date1_ = new moment(time1)
      .startOf("day")
      .toDate()
      .getTime();
    let date2_ = new moment(time2)
      .startOf("day")
      .toDate()
      .getTime();
    return date1_ === date2_;
  },

  getRangeOfYear(fromYear, toYear) {
    let from = new moment()
      .startOf("year")
      .year(fromYear)
      .toDate();
    let to = new moment()
      .startOf("year")
      .year(toYear + 1)
      .add("day", -1)
      .toDate();
    return [from, to];
  },

  truncDate(time) {
    return time
      ? moment(time)
          .startOf("day")
          .toDate()
          .getTime()
      : null;
  },

  calcWorkday(start, end) {
    if (!start || !end) return null;
    start = this.truncDate(start);
    end = new moment(this.truncDate(end)).add(1, "days");
    return moment(start).businessDiff(moment(end));
  }
};



// WEBPACK FOOTER //
// ./src/dateUtils.js